/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
// Local Deps
import { Row, Col } from 'reactstrap';


import {
  DeleteOutlined,
  FolderAddOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  FormOutlined,
  InboxOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  RobotOutlined,
  StarOutlined,

  ReadOutlined,
} from '@ant-design/icons';

import { Menu, Modal, Input, Dropdown, Button, Alert } from 'antd';

import './MessageCenter.scss';
import IHelpButton from '../../components/primitives/IHelpButton'
import SearchInputGroup from '../../components/SolicitationsSearchBar/subComponents/SearchInputGroup';
import MessageCenterGrid from '../../components/grids/MessageCenterGrid';
import MessageCenterHOC from './MessageCenterHOC';
import ViewMessages from '../ViewMessages';
import ComposeMessages from '../ComposeMessage';
import Subscription from '../../components/Subscription/Subscription';
// import Loading from '../../components/Loading';
const { SubMenu } = Menu;

class MessageCenter extends React.Component {
  static propTypes = {
    rawSelected: PropTypes.any.isRequired,
    selectedConversations: PropTypes.any.isRequired,
    selectAll: PropTypes.any.isRequired,
    getSelectedConversations: PropTypes.func.isRequired,
    changeSelectAllValue: PropTypes.func.isRequired,
    starred: PropTypes.any.isRequired,
    markConversationsStarred: PropTypes.func.isRequired,
    conversations: PropTypes.any.isRequired,
    setActiveFolder: PropTypes.func,
    setPageInfo: PropTypes.func.isRequired,
    folders: PropTypes.any,
    activeKey: PropTypes.any,
    openModal: PropTypes.bool.isRequired,
    selectedAction: PropTypes.func,
    handleFolderNameSubmission: PropTypes.func,
    handleCancel: PropTypes.func,
    handleFolderNameChange: PropTypes.func,
    showDeleteAction: PropTypes.bool.isRequired,
    confirmLoading: PropTypes.bool.isRequired,
    showMessage: PropTypes.bool.isRequired,
    setSelectedConvo: PropTypes.func.isRequired,
    saveDraft: PropTypes.func.isRequired,
    activeDraft: PropTypes.string.isRequired,
    onChangeDraft: PropTypes.func.isRequired,
    deleteDraft: PropTypes.func.isRequired,
    activeConversation: PropTypes.string.isRequired,
    conversationMessages: PropTypes.object.isRequired,
    addMessage: PropTypes.func.isRequired,
    showCompose: PropTypes.bool,
    setCurrentRecipients: PropTypes.func.isRequired,
    auth: PropTypes.shape({
      id: PropTypes.string,
      role: PropTypes.string,
      expiration: PropTypes.number,
      organizationId: PropTypes.string,
    }).isRequired,
    setTitle: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    onCompose: PropTypes.func.isRequired,
    errormsg: PropTypes.string.isRequired,
    onCloseError: PropTypes.func.isRequired,
    downloadAttachments: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    searchText: PropTypes.string,
    setSearchText: PropTypes.func.isRequired,
    requestSearch: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    fileList: PropTypes.any.isRequired,
    handleUploadChange: PropTypes.func.isRequired,
    handleUpload: PropTypes.func.isRequired,
    currentRecipients: PropTypes.any,
    pageNumber: PropTypes.number,
    downloadingAttachment: PropTypes.bool.isRequired,
    setMessageNotification: PropTypes.func.isRequired,
    selectAllConversationsInFolder: PropTypes.func.isRequired,
  };

  static defaultProps = {
    setActiveFolder: e => {
      console.log(e);
    },
    currentRecipients: [],
    searchText: '',
    folders: [
      'ACME Casting',
      'RFQ Agreements',
      'In Progress',
      'Waiting For a Response',
    ],
    pageNumber: 0,
    activeKey: ['folder-7'],
    selectedAction: (action, id = null, folderName = null) => {
      console.log(action, id, folderName);
    },
    handleFolderNameSubmission: () => {
      console.log('submit folder name');
    },
    handleCancel: () => {
      console.log("you've been cancelled");
    },
    handleFolderNameChange: e => {
      console.log(e.target.value);
    },
    showCompose: false,
  };

  render() {
    const {
      rawSelected,
      selectedConversations,
      setSearchText,
      selectAll,
      getSelectedConversations,
      changeSelectAllValue,
      starred,
      markConversationsStarred,
      conversations,
      setActiveFolder,
      folders,
      activeKey,
      openModal,
      selectedAction,
      handleFolderNameSubmission,
      handleCancel,
      handleFolderNameChange,
      showDeleteAction,
      confirmLoading,
      setPageInfo,
      setSelectedConvo,
      showMessage,
      saveDraft,
      activeDraft,
      onChangeDraft,
      deleteDraft,
      activeConversation,
      conversationMessages,
      addMessage,
      setCurrentRecipients,
      currentRecipients,
      auth,
      handleUploadChange,
      showCompose,
      title,
      onCompose,
      setTitle,
      errormsg,
      onCloseError,
      downloadAttachments,
      downloadingAttachment,
      searchText,
      requestSearch,
      handleUpload,
      fileList,
      pageNumber,
      onRemove,
      submitting,
      setMessageNotification,
      selectAllConversationsInFolder,
    } = this.props;
    const htmlFolders = folders.map(folder => {
      if (activeKey[0] === `folder-${folder}`) {
        return (
          <Menu.Item key={`folder-${folder}`}>
            <FolderOpenOutlined /> {folder}
          </Menu.Item>
        );
      }
      return (
        <Menu.Item key={`folder-${folder}`}>
          <FolderOutlined /> {folder}
        </Menu.Item>
      );
    });

    const menu = (
      <Menu
        onClick={e => {
          selectedAction('moveTo', null, e.key);
        }}
      >
        {htmlFolders}
        {activeKey[0] !== 'inbox' && (
          <Menu.Item key="folder-remove">
            <MinusCircleOutlined /> Move to Inbox
          </Menu.Item>
        )}
      </Menu>
    );

    return (
      <Subscription service="Message Center" level="ICON Plus">
        <div className="nf-account-admin message-center" >
          <div className="message-center-header">
            <Row>
              <Col xs="1" />

              <Col>
                <IHelpButton />
                <h1>Message Center</h1>
              </Col>
            </Row>
            <Row>
              <Col xs="4" />
              <Col className="searchbar">
                {' '}
                <SearchInputGroup
                  onSearchButtonClick={requestSearch}
                  onSearchInputChange={setSearchText}
                  searchText={searchText}
                />
              </Col>
            </Row>
            {errormsg && (
              <Alert
                message="Error"
                description={errormsg}
                type="error"
                closable
                showIcon
                afterClose={onCloseError}
              />
            )}
            {selectAll === 1 && (
              <Row style={{ display: 'flex', justifyContent: 'center' }}>
                {' '}
                {Object.keys(rawSelected).length !== conversations.length ? (
                  <div className="select-all">
                    All&nbsp;<b>{20}</b>&nbsp;conversations on this page are
                    selected.
                    <Button
                      style={{ background: '#dfdfdf', color: 'blue' }}
                      onClick={selectAllConversationsInFolder}
                    >
                      Select all {conversations.length} conversations in{' '}
                      {activeKey[0].replace('folder-', '')}
                    </Button>
                  </div>
                ) : (
                  <div className="select-all">
                    All&nbsp;<b>{conversations.length}</b>&nbsp;conversations in{' '}
                    {activeKey[0].replace('folder-', '')} are selected.
                    <Button
                      style={{ background: '#dfdfdf', color: 'blue' }}
                      onClick={() => {
                        changeSelectAllValue({}, 0);
                      }}
                    >
                      Clear Selection
                    </Button>
                  </div>
                )}
              </Row>
            )}
            <div className="message-center-actions-wrapper">
              {!showMessage && (
                <div className="message-center-actions">
                  <button
                    onClick={() => {
                      selectedAction('newMessage');
                    }}
                  >
                    <PlusCircleOutlined /> New Message
                  </button>
                  {activeKey[0] !== 'drafts' && (
                    <button
                      disabled={!selectedConversations[0]}
                      onClick={() => {
                        selectedAction('markAsRead', null, null);
                      }}
                    >
                      <ReadOutlined /> Mark as Read
                    </button>
                  )}
                  {activeKey[0] !== 'drafts' && (
                    <button disabled={!selectedConversations[0]}>
                      <Dropdown
                        overlay={menu}
                        trigger={['click']}
                        disabled={!selectedConversations[0]}
                      >
                        <a href>
                          <RobotOutlined /> Move to Folder
                        </a>
                      </Dropdown>
                    </button>
                  )}
                  {activeKey[0] !== 'drafts' && activeKey[0] !== 'archived' && (
                    <button
                      disabled={!selectedConversations[0]}
                      onClick={() => {
                        selectedAction('moveTo', null, 'archived');
                      }}
                    >
                      <i className="fa fa-archive" /> Archive
                    </button>
                  )}

                  {activeKey[0] === 'drafts' && (
                    <button
                      disabled={!selectedConversations[0]}
                      onClick={() => {
                        selectedAction('deleteDrafts', null, null);
                      }}
                    >
                      <DeleteOutlined /> Delete Drafts
                    </button>
                  )}
                  {showDeleteAction &&
                    activeKey[0].includes('folder-') && (
                      <button
                        onClick={() => {
                          selectedAction('deleteFolder', null, null);
                        }}
                      >
                        <MinusCircleOutlined /> Delete Folder
                      </button>
                    )}
                </div>
              )}
            </div>
          </div>

          <Row className="message-center-body">
            <Col xs="2" className="message-center-sidemenu">
              <Menu
                selectedKeys={activeKey}
                mode="inline"
                onClick={setActiveFolder}
              // inlineCollapsed={this.state.collapsed}
              >
                <Menu.Item key="newMessage">
                  <PlusCircleOutlined />
                  <span>New Message</span>
                </Menu.Item>
                <Menu.Divider />

                <Menu.Item key="inbox">
                  <InboxOutlined />
                  <span>INBOX</span>
                </Menu.Item>

                <SubMenu
                  key="sub1"
                  title={
                    <span>
                      {activeKey[0].includes('folder') ? (
                        <FolderOpenOutlined />
                      ) : (
                        <FolderOutlined />
                      )}
                      <span>FOLDERS</span>
                    </span>
                  }
                >
                  {htmlFolders}
                  <Menu.Item key="folder-add">
                    <FolderAddOutlined />
                    Add New Folder
                  </Menu.Item>
                </SubMenu>
                <Menu.Item key="drafts">
                  <FormOutlined /> <span>DRAFTS</span>
                </Menu.Item>

                <Menu.Item key="starred">
                  <StarOutlined /> <span>STARRED</span>
                </Menu.Item>
                <Menu.Item key="archived">
                  <i className="fa fa-archive" /> <span>ARCHIVED</span>
                </Menu.Item>
              </Menu>
            </Col>
            <Col className="message-center-table">
              {!showMessage &&
                !showCompose && (
                  <MessageCenterGrid
                    setPageInfo={setPageInfo}
                    conversations={conversations}
                    rawSelected={rawSelected}
                    selectedConversations={selectedConversations}
                    selectAll={selectAll}
                    getSelectedConversations={getSelectedConversations}
                    changeSelectAllValue={changeSelectAllValue}
                    markConversationsStarred={markConversationsStarred}
                    starred={starred}
                    setSelectedConvo={setSelectedConvo}
                    selectedAction={selectedAction}
                    pageNumber={pageNumber}
                    setMessageNotification={setMessageNotification}
                    activeKey={activeKey}
                  />
                )}
              {showCompose && (
                <ComposeMessages
                  setTitle={setTitle}
                  title={title}
                  auth={auth}
                  conversationMessages={conversationMessages}
                  activeConversation={activeConversation}
                  saveDraft={saveDraft}
                  activeDraft={activeDraft}
                  onChangeDraft={onChangeDraft}
                  deleteDraft={deleteDraft}
                  setCurrentRecipients={setCurrentRecipients}
                  currentRecipients={currentRecipients}
                  addMessage={addMessage}
                  onCompose={onCompose}
                  onSubmit={addMessage}
                  fileList={fileList}
                  handleUploadChange={handleUploadChange}
                  handleUpload={handleUpload}
                  onRemove={onRemove}
                  submitting={submitting}
                />
              )}
              {showMessage && (
                <ViewMessages
                  auth={auth}
                  conversationMessages={conversationMessages}
                  activeConversation={activeConversation}
                  saveDraft={saveDraft}
                  activeDraft={activeDraft}
                  onChangeDraft={onChangeDraft}
                  deleteDraft={deleteDraft}
                  downloadAttachments={downloadAttachments}
                  downloadingAttachment={downloadingAttachment}
                  onSubmit={addMessage}
                  fileList={fileList}
                  handleUploadChange={handleUploadChange}
                  handleUpload={handleUpload}
                  onRemove={onRemove}
                  submitting={submitting}
                />
              )}
            </Col>
            <Modal
              title="New Folder"
              visible={openModal}
              centered
              confirmLoading={confirmLoading}
              onClick={selectedAction}
              onOk={handleFolderNameSubmission}
              onCancel={handleCancel}
              footer={[
                <Button key="back" onClick={handleCancel}>
                  Cancel
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  disabled={false}
                  onClick={handleFolderNameSubmission}
                >
                  Submit
                </Button>,
              ]}
            >
              <Input
                onChange={handleFolderNameChange}
                placeholder="Enter Folder Name Here"
              />
            </Modal>
          </Row>
        </div>
      </Subscription>
    );
  }
}

export default MessageCenterHOC(MessageCenter);



// WEBPACK FOOTER //
// ./src/pages/messageCenter/MessageCenter.jsx